import React, { useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";

const InstallmentSelector = ({ installments, onChange }) => {
  const [selectedInstallments, setSelectedInstallments] = useState(
    installments[0]?.installmentAmount || 1
  );

  const handleChange = (event) => {
    const value = parseInt(event.target.value);
    setSelectedInstallments(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <select
      value={selectedInstallments}
      onChange={handleChange}
      className="installment-select"
      style={{
        padding: "10px",
        borderRadius: "4px",
        width: "100%",
        margin: "20px 0",
        fontSize: "16px",
      }}
    >
      {installments.map((option) => (
        <option key={option.installmentAmount} value={option.installmentAmount}>
          {option.installmentAmount}x de R${" "}
          {option.installmentValue.toFixed(2).replace(".", ",")}
          {option.installmentAmount === 1 ? " à vista" : option.installmentAmount <= 6 ? " (s/ juros)" : " (c/ juros)"}
        </option>
      ))}
    </select>
  );
};

const InstallmentsPage = ({
  installments,
  onCancel,
  onContinue,
  isLoading,
  loadingMessage,
  errorMessage,
  noticeMessage,
  requireCvv,
  cardBlocked,
  onChooseAnotherCard,
  onBackToStore,
}) => {
  // Cria um estado para armazenar o número de parcelas selecionado
  const [selectedInstallment, setSelectedInstallment] = useState(
    installments[0]?.installmentAmount || 1
  );
  const [cvv, setCvv] = useState("");
  const [cvvError, setCvvError] = useState("");

  // Função para lidar com o botão Continuar
  const handleContinue = () => {
    if (requireCvv) {
      const clean = cvv.replace(/\D/g, "");
      if (clean.length < 3) {
        setCvvError("Informe o código de segurança do cartão.");
        return;
      }
      setCvvError("");
      onContinue(selectedInstallment, clean);
      return;
    }
    // Passa o valor selecionado para a função onContinue
    onContinue(selectedInstallment);
  };

  return (
    <div className="modal" style={{ width: "425px" }}>
      <button
        className="close"
        onClick={onCancel}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "-10px",
          top: "-10px",
          width: "36px",
          height: "36px",
          fontSize: "24px",
          background: "#D11A2A",
          borderRadius: "18px",
          border: "1px solid #cfcece",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          lineHeight: "normal",
          padding: 0,
        }}
      >
        ×
      </button>
      <img className="logo" src={"/img/raidhut.png"} alt="raidhut-logo" />
      <h1 className="modal-title">Pagamento com PicPay</h1>
      <h3 className="modal-subtext">Selecione o número de parcelas:</h3>

      {/* Passa a função para receber o valor selecionado */}
      <InstallmentSelector
        installments={installments}
        onChange={setSelectedInstallment}
      />

      {/*
        O CVV volta a ser pedido em recompra com cartão salvo porque o endpoint de autorização
        3DS o exige como obrigatório — é a única mudança do fluxo novo com atrito direto para o
        comprador. Em cartão novo ele já é digitado no formulário anterior.
      */}
      {requireCvv && (
        <div style={{ margin: "12px 0", textAlign: "left" }}>
          <label
            htmlFor="picpay-cvv"
            style={{ display: "block", fontSize: "14px", marginBottom: "6px" }}
          >
            Código de segurança (CVV)
          </label>
          <input
            id="picpay-cvv"
            type="tel"
            inputMode="numeric"
            autoComplete="cc-csc"
            maxLength={4}
            value={cvv}
            onChange={(e) => {
              setCvv(e.target.value.replace(/\D/g, ""));
              if (cvvError) setCvvError("");
            }}
            placeholder="123"
            aria-invalid={cvvError ? "true" : "false"}
            style={{
              padding: "10px",
              borderRadius: "4px",
              width: "100%",
              fontSize: "16px",
              border: cvvError ? "1px solid #D11A2A" : "1px solid #cfcece",
              boxSizing: "border-box",
            }}
          />
          {cvvError && (
            <div style={{ color: "#D11A2A", marginTop: "6px", fontSize: "13px" }}>
              {cvvError}
            </div>
          )}
        </div>
      )}

      {errorMessage && (
        <div style={{ color: "#D11A2A", marginTop: "10px", marginBottom: "10px", textAlign: "center", fontSize: "14px", fontWeight: "bold" }}>
          {errorMessage}
        </div>
      )}

      {/* Aviso de tentativas restantes do cartao: abaixo da recusa, com menos peso que ela. */}
      {noticeMessage && (
        <div style={{ color: "#9a6700", marginTop: "-4px", marginBottom: "10px", textAlign: "center", fontSize: "13px" }}>
          {noticeMessage}
        </div>
      )}

      {/*
        Depois de uma falha as saidas ficam explicitas, como na tela de recusa da verificacao: o X
        do canto nao diz se volta para os cartoes ou para a loja.
          - cartao bloqueado: so trocar de cartao ou sair -- tentar de novo com ele nao passa;
          - recusa ou erro: tentar de novo com o mesmo cartao, trocar, ou sair.
      */}
      {!cardBlocked && (
      <button
        className="copy-button"
        onClick={handleContinue}
        disabled={isLoading}
        style={{ marginTop: "20px" }}
      >
        {isLoading ? (
          <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
            <ProgressSpinner style={{ width: "16px", height: "16px", margin: 0, flexShrink: 0 }} strokeWidth="8" />
            <span style={loadingMessage ? { fontSize: "15px" } : {}}>
              {loadingMessage || "Carregando..."}
            </span>
          </span>
        ) : errorMessage ? (
          "Tentar novamente"
        ) : (
          "Continuar"
        )}
      </button>
      )}

      {(cardBlocked || errorMessage) && !isLoading && (
        <>
          <button
            className="copy-button"
            onClick={onChooseAnotherCard}
            style={
              cardBlocked
                ? { marginTop: "20px" }
                : { marginTop: "10px", background: "#f0f0f0", color: "#333" }
            }
          >
            Usar outro cartão
          </button>
          <button
            onClick={onBackToStore}
            style={{
              display: "block",
              margin: "14px auto 0",
              background: "none",
              border: "none",
              color: "#666",
              textDecoration: "underline",
              cursor: "pointer",
              fontSize: "0.9rem",
            }}
          >
            Voltar para a loja
          </button>
        </>
      )}
    </div>
  );
};

export default InstallmentsPage;
